import React from 'react';
import PropTypes from 'prop-types';
import t from '../../../../translations';
// uses ./AppDomainSettings.less

const AppDomainSettingsActionBoxEdit = ({ openSettings }) => (
    <div className="ast-app-configuration__action-box-edit ">
        <div>
            <p className="txt-semi-bold">{t.AppDomainSettings.configuration}</p>
            <p className="sg-txt-light">{t.AppDomainSettings.subInformationEdit}</p>
        </div>
        <button type="button" onClick={openSettings} className="sg-button-action ast-app-configuration__link">
            {t.AppDomainSettings.buttonEdit}
        </button>
    </div>
);

AppDomainSettingsActionBoxEdit.propTypes = {
    openSettings: PropTypes.func.isRequired,
};

export default AppDomainSettingsActionBoxEdit;
